import { combineReducers, configureStore } from "@reduxjs/toolkit";
import userInfoSlice from "../store/userInfoSlice";
import usersListSlice from "../store/usersListSlice";
import storage from "redux-persist/lib/storage";
import { persistReducer, persistStore } from "redux-persist";

const persistConfig = {
  key: "userInfo",
  storage,
};

const persistedUserInfoReducer = persistReducer(persistConfig, userInfoSlice);

const rootReducer = combineReducers({
  userInfo: persistedUserInfoReducer,
  userList: usersListSlice,
});


export const store = configureStore({
  reducer: rootReducer,
});

export const persistor = persistStore(store);
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
